import React from 'react';

const About = () => {
    return (
        <div className="shadow-lg p-3 mb-5 bg-body rounded">
           <center><h1>About Teachdemy </h1></center>

            <p>teachdemy is a platform that allows instructors to build online courses on their preferred topics. Using  course development tools, they can upload videos, PowerPoint presentations, PDFs, audio, ZIP files and live classes to create courses. Instructors can also engage and interact with users via online discussion boards.

Courses are offered across a breadth of categories, including business and entrepreneurship, academics, the arts, health and fitness, language, music, and technology.Most classes are in practical subjects such as Excel software or using an iPhone camera.TeachUdemy also offers Udemy for Business, enabling businesses access to a targeted suite of over 7,000 training courses on topics from digital marketing tactics to office productivity, design, management, programming, and more. With Udemy for Business, organizations can also create custom learning portals for corporate training.</p>
        </div>
    );
};

export default About;